
export function getEnumDisplayNameByConstant(enumPairs : any, constantValue : string) {
    if (constantValue) {
        return Array.isArray(enumPairs) && enumPairs.find(enumPair => constantValue === enumPair?.constant)?.value;
    }
}
